import { render, staticRenderFns } from "./OpenNew.vue?vue&type=template&id=0dbfd4d6&"
import script from "./OpenNew.vue?vue&type=script&lang=js&"
export * from "./OpenNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports